import { useQuery } from 'react-query';
import Cookies from 'js-cookie';
import httpRequest from '@utils/httpRequest';
import { storageKeys } from '@constants';

// 用户、租户切换后不能沿用上个会话的内部合同授权。
export default function useInternalContractAccess() {
  const token = Cookies.get(storageKeys.token);
  const tenant = Cookies.get(storageKeys.tenantCode);
  const query = useQuery(['internalContractAccess', tenant, token], async () => {
    const response = await httpRequest.get('/admin/internalContractPermission/me');
    if (response.code !== 0) throw new Error(response.msg || '获取内部合同权限失败');
    return response.data;
  }, {
    enabled: !!token, staleTime: 60000, refetchOnWindowFocus: false, refetchInterval: false, retry: false,
  });
  return { ...query, scopeKey: `${tenant}:${token}` };
}
